import { render, staticRenderFns } from "./listAlerts.vue?vue&type=template&id=63e772a6&scoped=true&"
import script from "./listAlerts.vue?vue&type=script&lang=js&"
export * from "./listAlerts.vue?vue&type=script&lang=js&"
import style0 from "./listAlerts.vue?vue&type=style&index=0&id=63e772a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e772a6",
  null
  
)

export default component.exports